package tta.destinigo.talktoastro.feature_profile.refer_and_earn.data.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MyEarningImageResponse(
    @SerialName("url") val path :String?
)
